
import { login, getUserInfo, userLogout } from '../../server/me';
import { clearCookie, setCookie, getCookie } from '../../utils/utils';

const state = {
  userId: '',
  sessionKey: '',
  userInfo: {},
  isShowLogin: false,
  headerUserinfoShow: false
}

const mutations = {
  SET_UID: (state, userId) => {
    state.userId = userId;
  },
  SET_SEEIONKEY: (state, sessionKey) => {
    state.sessionKey = sessionKey;
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo;
  },
  OPEN_LOGIN: (state, boolean) => {
    state.isShowLogin = boolean;
  },
  SET_HEADER_USERINFO_SHOW: (state, boolean) => {
    state.headerUserinfoShow = boolean;
  },
  CLEAR_USER_INFO() {
    state.userId = '';
    state.sessionKey = '';
    state.userInfo = {};
    clearCookie('uid');
    clearCookie('sessionkey');
  }
}

const actions = {
  // user login
  loginHandler({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo).then(response => {
        const { code = 1 } = response;
        if (code === 0) {
          const { data } = response
          data.name = data.nickname;
          commit('SET_UID', data.userId)
          commit('SET_SEEIONKEY', data.sessionKey)
          commit('SET_USERINFO', data)
          commit('SET_HEADER_USERINFO_SHOW', true)
          resolve(response)
        } else {
          resolve(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getUserInfo().then(response => {
        const { code = 1, msg = '', ...res } = response
        if (code === 0) {
          const { data} = res
          const userInfo = data.userInfo;
          const { id } = userInfo;
          const sessionKey = getCookie('sessionkey');
          setCookie('uid', id, 1);
          setCookie('sessionkey', sessionKey, 1);
          commit('SET_UID', id)
          commit('SET_SEEIONKEY', sessionKey)
          commit('SET_USERINFO', userInfo)
          commit('SET_HEADER_USERINFO_SHOW', true)
          resolve(response)
        }
      }).catch(error => {
        reject(error)
      })
    })
  },
  openLogin({commit}, boolean) {
    commit('OPEN_LOGIN', boolean)
  },
  logout({commit}) {
    return new Promise((resolve, reject) => {
      userLogout().then(response => {
        commit('CLEAR_USER_INFO');
        commit('SET_HEADER_USERINFO_SHOW', false)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
    
  },
  clearUserInfo({commit}) {
    commit('CLEAR_USER_INFO');
    commit('SET_HEADER_USERINFO_SHOW', false)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js